import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Box, Container, useMediaQuery } from "@material-ui/core";

import { Timer } from "./Timer";
import { setHours, setMinutes, setSeconds } from "date-fns";
import { useSaleBannerStyles } from "./saleBanner.styles";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { RootState } from "../../app/rootReducer";
import { useQuoteAvailableDeductions } from "../../api/Deduction/DeductionApi";
import { PriceFormat } from "../typography/PriceFormat";

export const SaleBanner = ({ quoteId }: { quoteId: string }) => {
  const classes = useSaleBannerStyles();
  const { isMoreThanSm, isMoreThanMd } = useBreakpoint();
  const matches = useMediaQuery("(max-width:400px)");

  const { quote } = useSelector((state: RootState) => state.quote);

  const { data, refetch } = useQuoteAvailableDeductions(quoteId);
  useEffect(() => {
    if (quoteId) {
      refetch();
    }
  }, [quoteId, refetch]);

  let deduction = data && data.length ? data[0] : null;
  if (!deduction) {
    return null;
  } else if (deduction.expireInDays) {
    let expiryDate = new Date(quote?.sent ? quote.sent : 0);
    expiryDate.setDate(expiryDate.getDate() + deduction.expireInDays);
    deduction.expiryDate = expiryDate.toString();
  }
  return (
    <Box
      minHeight={isMoreThanMd || !isMoreThanSm ? "56px" : "75px"}
      bgcolor={"#1e073f"}
      display={"flex"}
      alignItems={"center"}
    >
      <Container maxWidth="lg">
        <Box
          display={"flex"}
          alignItems={"center"}
          width="full"
          flexWrap={"wrap"}
          justifyContent={"center"}
          className={`${classes.saleBanner} ${matches ? classes.fontSizeSm : ""}`}
        >
          <Box display={"flex"} alignItems={"center"} mr={isMoreThanSm ? "46px" : 0}>
            <span style={{ marginTop: isMoreThanSm ? "4px" : 0 }}>SALE ENDS IN</span>{" "}
            {deduction.expiryDate && (
              <Timer deadline={setSeconds(setMinutes(setHours(new Date(deduction.expiryDate), 23), 59), 59)} />
            )}
          </Box>
          <Box display={"flex"} alignItems={"center"} mt="4px">
            <span style={{ marginRight: isMoreThanSm ? "36px" : "10px", height: "100%", textTransform: "uppercase" }}>
              {deduction.timedOfferText}{" "}
              <span className={classes.colorOrange}>
                {deduction.type === "Percent" ? `${deduction.value}%` : <PriceFormat value={deduction.value} />}
              </span>
            </span>
            <span>
              ⌛️ USE CODE: <span className={classes.colorOrange}>{deduction.promoCode}</span>
            </span>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
